// extracted by mini-css-extract-plugin
export var arrow = "_3y-6";
export var changeItem = "_3y-3";
export var changesHeader = "_3y-1";
export var changesList = "_3y-2";
export var container = "_3y-0";
export var pathLabel = "_3y-4";
export var value = "_3y-7";
export var valuesContainer = "_3y-5";